(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inner-ring-image-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // 全局仅注册一次，避免 Shopify Theme Editor 重复注入脚本。
    if (!window.PcInnerRingCarousel) {
      const ROOT_SELECTOR = '[data-inner-ring-section]';

      class InnerRingCarousel {
        constructor(root) {
          this.root = root;
          this.carousel = root.querySelector('[data-ring-carousel]');
          this.scene = root.querySelector('[data-ring-scene]');
          this.modal = root.querySelector('[data-ring-video-modal]');
          this.modalPlayer = root.querySelector('[data-ring-video-player]');
          this.modalOriginalParent = this.modal?.parentNode || null;
          this.modalNextSibling = this.modal?.nextSibling || null;

          root.querySelectorAll('[data-ring-clone]').forEach((card) => card.remove());
          this.originalCards = Array.from(root.querySelectorAll('[data-ring-card]'));
          this.cards = [...this.originalCards];

          if (!this.carousel || !this.scene || this.cards.length === 0) return;

          this.root.dataset.initialized = 'true';
          this.progressText = root.querySelector('[data-ring-progress-text]');
          this.progressFill = root.querySelector('[data-ring-progress-fill]');
          this.count = this.originalCards.length;
          this.renderCount = this.cards.length;
          this.activeRenderIndex = -1;
          this.originalCards.forEach((card, index) => {
            card.dataset.sourceIndex = String(index);
          });

          this.mobileQuery = window.matchMedia('(max-width: 768px)');
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoplay = root.dataset.autoplay === 'true';
          this.pauseOnHover = root.dataset.pauseOnHover === 'true';
          this.desktopSpeed = this.numberValue(root.dataset.desktopSpeed, 68) / 100;
          this.mobileDelay = this.numberValue(root.dataset.mobileDelay, 3200);
          this.desktopGapFallback = this.numberValue(root.dataset.desktopGap, 20);
          this.mobileGapFallback = this.numberValue(root.dataset.mobileGap, 14);

          this.cardWidth = 0;
          this.cardStep = 0;
          this.position = 0;
          this.target = 0;
          this.velocity = 0;
          this.isMobile = this.mobileQuery.matches;
          this.isDragging = false;
          this.hoverPaused = false;
          this.modalPaused = false;
          this.lastFocusedElement = null;
          this.suppressClick = false;
          this.dragDistance = 0;
          this.pointerStartX = 0;
          this.pointerStartY = 0;
          this.pointerLastX = 0;
          this.pointerLastTime = 0;
          this.positionAtPointerDown = 0;
          this.pointerId = null;
          this.axisLock = null;
          this.lastFrame = performance.now();
          this.lastMobileAdvance = this.lastFrame;
          this.inViewport = true;
          this.animationFrame = null;
          this.measureFrame = null;
          this.resizeTimer = null;
          this.abortController = new AbortController();
          this.root.__pcInnerRingCarousel = this;

          this.bindEvents();
          this.bindObservers();
          this.measure();
          this.draw();
          this.startAnimation();
        }

        numberValue(value, fallback) {
          const parsed = Number(value);
          return Number.isFinite(parsed) ? parsed : fallback;
        }

        cssPixelValue(propertyName, fallback) {
          const value = Number.parseFloat(getComputedStyle(this.root).getPropertyValue(propertyName));
          return Number.isFinite(value) ? value : fallback;
        }

        bindEvents() {
          const signal = this.abortController.signal;

          this.carousel.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
          this.carousel.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
          this.carousel.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
          this.carousel.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal });
          this.carousel.addEventListener('lostpointercapture', (event) => this.onPointerUp(event), { signal });
          this.carousel.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
          this.carousel.addEventListener(
            'click',
            (event) => {
              if (this.suppressClick) event.preventDefault();
            },
            { capture: true, signal }
          );
          this.carousel.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });

          this.root.addEventListener(
            'click',
            (event) => {
              const trigger = event.target.closest?.('[data-ring-video-trigger]');
              if (!trigger || !this.root.contains(trigger)) return;

              event.preventDefault();
              event.stopPropagation();
              if (this.suppressClick) return;

              this.openVideoModal(trigger.dataset.videoBlockId, trigger);
            },
            { signal }
          );

          this.modal?.addEventListener(
            'click',
            (event) => {
              if (event.target.closest?.('[data-ring-video-close]')) {
                event.preventDefault();
                this.closeVideoModal();
              }
            },
            { signal }
          );

          document.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape' && this.modalPaused) {
                event.preventDefault();
                this.closeVideoModal();
              }
            },
            { signal }
          );

          if (this.pauseOnHover) {
            this.carousel.addEventListener(
              'mouseenter',
              () => {
                this.hoverPaused = true;
              },
              { signal }
            );
            this.carousel.addEventListener(
              'mouseleave',
              () => {
                this.hoverPaused = false;
                this.lastMobileAdvance = performance.now();
                this.startAnimation();
              },
              { signal }
            );
          }

          this.modeChangeHandler = () => this.onModeChange();
          if (typeof this.mobileQuery.addEventListener === 'function') {
            this.mobileQuery.addEventListener('change', this.modeChangeHandler, { signal });
          } else if (typeof this.mobileQuery.addListener === 'function') {
            this.mobileQuery.addListener(this.modeChangeHandler);
          }

          document.addEventListener(
            'visibilitychange',
            () => {
              this.lastFrame = performance.now();
              this.lastMobileAdvance = this.lastFrame;
              if (document.hidden) {
                this.stopAnimation();
              } else if (this.inViewport) {
                this.startAnimation();
              }
            },
            { signal }
          );
        }

        bindObservers() {
          // 合并尺寸变化测量，并在模块离开可视区域时停止动画帧。
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
            this.resizeObserver.observe(this.carousel);
          } else {
            window.addEventListener(
              'resize',
              () => {
                window.clearTimeout(this.resizeTimer);
                this.resizeTimer = window.setTimeout(() => this.scheduleMeasure(), 150);
              },
              { signal: this.abortController.signal }
            );
          }

          if ('IntersectionObserver' in window) {
            this.inViewport = false;
            this.intersectionObserver = new IntersectionObserver(
              (entries) => {
                const entry = entries[0];
                this.inViewport = Boolean(entry?.isIntersecting);
                this.lastFrame = performance.now();
                this.lastMobileAdvance = this.lastFrame;

                if (this.inViewport && !document.hidden) {
                  this.startAnimation();
                } else {
                  this.stopAnimation();
                }
              },
              { rootMargin: '200px 0px' }
            );
            this.intersectionObserver.observe(this.root);
          }
        }

        scheduleMeasure() {
          if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
          this.measureFrame = requestAnimationFrame(() => {
            this.measureFrame = null;
            this.measure();
          });
        }

        measure() {
          const firstCard = this.originalCards[0];
          if (!firstCard || !this.carousel.clientWidth) return;

          this.isMobile = this.mobileQuery.matches;
          this.cardWidth = firstCard.getBoundingClientRect().width;
          const gapProperty = this.isMobile ? '--pc-ring-mobile-gap' : '--pc-ring-desktop-gap';
          const gapFallback = this.isMobile ? this.mobileGapFallback : this.desktopGapFallback;
          const responsiveGap = this.cssPixelValue(gapProperty, gapFallback);

          if (this.cardWidth > 0) {
            this.cardStep = this.cardWidth + responsiveGap;
            this.syncRenderCards();
          }

          this.draw();
        }

        syncRenderCards() {
          // 根据当前容器宽度按需创建最少克隆，避免注入过多 DOM。
          if (!this.scene || !this.cardStep || this.count === 0) return;

          if (this.count < 2) {
            this.root.querySelectorAll('[data-ring-clone]').forEach((card) => card.remove());
            this.cards = [...this.originalCards];
            this.renderCount = this.cards.length;
            this.activeRenderIndex = -1;
            return;
          }

          const visibleLimit = this.carousel.clientWidth / 2 + this.cardWidth;
          const minimumCards = Math.ceil((visibleLimit * 2) / this.cardStep) + 4;
          const repeatSets = Math.max(2, Math.ceil(minimumCards / this.count));
          const desiredCount = repeatSets * this.count;

          if (desiredCount === this.renderCount) return;

          this.root.querySelectorAll('[data-ring-clone]').forEach((card) => card.remove());
          const fragment = document.createDocumentFragment();

          for (let index = this.count; index < desiredCount; index += 1) {
            const sourceIndex = index % this.count;
            const clone = this.originalCards[sourceIndex].cloneNode(true);
            clone.dataset.ringClone = 'true';
            clone.dataset.sourceIndex = String(sourceIndex);
            clone.classList.remove('is-active', 'is-render-visible');
            clone.removeAttribute('aria-current');
            clone.setAttribute('aria-hidden', 'true');

            if (clone.matches('a')) clone.tabIndex = -1;

            [clone, ...clone.querySelectorAll('*')].forEach((element) => {
              Array.from(element.attributes).forEach((attribute) => {
                if (attribute.name.startsWith('data-shopify')) {
                  element.removeAttribute(attribute.name);
                }
              });
              element.removeAttribute('id');
            });

            clone.querySelectorAll('template').forEach((template) => template.remove());
            clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
              element.tabIndex = -1;
            });
            clone.querySelectorAll('img').forEach((image) => {
              image.loading = 'lazy';
              image.fetchPriority = 'auto';
            });

            fragment.appendChild(clone);
          }

          this.scene.appendChild(fragment);
          this.cards = [...this.originalCards, ...this.root.querySelectorAll('[data-ring-clone]')];
          this.renderCount = this.cards.length;
          this.activeRenderIndex = -1;
        }

        onModeChange() {
          if (this.modalPaused) this.closeVideoModal({ restoreFocus: false });

          const wasMobile = this.isMobile;
          this.isMobile = this.mobileQuery.matches;

          if (this.isMobile && !wasMobile) {
            this.target = Math.round(this.position);
          } else if (!this.isMobile) {
            this.target = this.position;
          }

          this.velocity = 0;
          this.lastMobileAdvance = performance.now();
          this.scheduleMeasure();
          this.startAnimation();
        }

        onPointerDown(event) {
          if (event.target.closest?.('[data-ring-video-trigger]')) return;
          if ((event.button !== undefined && event.button !== 0) || this.count < 2) return;

          this.isDragging = true;
          this.pointerId = event.pointerId;
          this.axisLock = null;
          this.dragDistance = 0;
          this.pointerStartX = event.clientX;
          this.pointerStartY = event.clientY;
          this.pointerLastX = event.clientX;
          this.pointerLastTime = performance.now();
          this.positionAtPointerDown = this.position;
          this.target = this.position;
          this.velocity = 0;
          this.carousel.classList.add('is-dragging');
          this.carousel.setPointerCapture?.(event.pointerId);
          this.startAnimation(true);
        }

        onPointerMove(event) {
          if (!this.isDragging || event.pointerId !== this.pointerId || !this.cardStep) return;

          const movementFromStart = event.clientX - this.pointerStartX;
          const verticalMovement = event.clientY - this.pointerStartY;

          // 移动端先判断滑动方向，纵向手势继续交给页面滚动。
          if (this.isMobile && !this.axisLock) {
            if (Math.abs(verticalMovement) > Math.abs(movementFromStart) && Math.abs(verticalMovement) > 6) {
              this.cancelDrag(event);
              return;
            }
            if (Math.abs(movementFromStart) <= 6) return;
            this.axisLock = 'x';
          }

          const currentTime = performance.now();
          const movementFromLastPoint = event.clientX - this.pointerLastX;
          const elapsedTime = Math.max(currentTime - this.pointerLastTime, 1);

          this.dragDistance = Math.max(this.dragDistance, Math.abs(movementFromStart));
          this.position = this.positionAtPointerDown - movementFromStart / this.cardStep;
          this.target = this.position;
          this.velocity = this.clamp(
            -(movementFromLastPoint / this.cardStep / elapsedTime) * 1000,
            -4,
            4
          );

          this.pointerLastX = event.clientX;
          this.pointerLastTime = currentTime;
          event.preventDefault();
          this.draw();
        }

        cancelDrag(event) {
          this.isDragging = false;
          this.pointerId = null;
          this.axisLock = null;
          this.velocity = 0;
          this.target = this.positionAtPointerDown;
          this.carousel.classList.remove('is-dragging');
          this.carousel.releasePointerCapture?.(event.pointerId);
        }

        onPointerUp(event) {
          if (!this.isDragging || event.pointerId !== this.pointerId) return;

          this.isDragging = false;
          this.pointerId = null;
          this.axisLock = null;
          this.carousel.classList.remove('is-dragging');
          this.carousel.releasePointerCapture?.(event.pointerId);

          if (this.isMobile) {
            const movedCards = this.position - this.positionAtPointerDown;
            const shouldAdvance = this.dragDistance > 32 || Math.abs(this.velocity) > 0.35;
            const direction = Math.sign(Math.abs(movedCards) > 0.04 ? movedCards : this.velocity);

            this.target = Math.round(this.positionAtPointerDown) + (shouldAdvance ? direction : 0);
            this.velocity = 0;

            if (this.reducedMotionQuery.matches) {
              this.position = this.target;
              this.draw();
            }
          }

          if (this.dragDistance > 6) {
            this.suppressClick = true;
            window.setTimeout(() => {
              this.suppressClick = false;
            }, 0);
          }

          this.lastMobileAdvance = performance.now();
        }

        onKeyDown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (this.count < 2) return;

          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;

          if (this.isMobile) {
            this.target = Math.round(this.position) + direction;
          } else {
            this.position = Math.round(this.position) + direction;
            this.target = this.position;
            this.velocity = 0;
          }

          this.lastMobileAdvance = performance.now();
          this.startAnimation(true);
          this.draw();
        }

        findVideoTemplate(blockId, mode) {
          return Array.from(this.root.querySelectorAll(`template[data-ring-video-template="${mode}"]`)).find(
            (template) => template.dataset.blockId === blockId
          );
        }

        openVideoModal(blockId, trigger) {
          if (!this.modal || !this.modalPlayer || !blockId) return;

          const preferredMode = this.mobileQuery.matches ? 'mobile' : 'desktop';
          const fallbackMode = preferredMode === 'mobile' ? 'desktop' : 'mobile';
          const template = this.findVideoTemplate(blockId, preferredMode) || this.findVideoTemplate(blockId, fallbackMode);
          if (!template) return;

          this.lastFocusedElement = trigger instanceof HTMLElement ? trigger : null;
          this.modalPaused = true;
          this.velocity = 0;
          this.target = this.position;
          this.stopAnimation();

          this.modalPlayer.replaceChildren(template.content.cloneNode(true));
          document.body.appendChild(this.modal);
          this.modal.hidden = false;
          this.modal.setAttribute('aria-hidden', 'false');
          this.modal.classList.add('is-open');
          document.documentElement.classList.add('pc-inner-ring-modal-open');

          requestAnimationFrame(() => {
            this.modal?.querySelector('[data-ring-video-close]')?.focus({ preventScroll: true });
            const video = this.modalPlayer?.querySelector('video');
            video?.play().catch(() => {});
          });
        }

        restoreModalPosition() {
          if (!this.modal || !this.modalOriginalParent) return;

          if (this.modalNextSibling && this.modalNextSibling.parentNode === this.modalOriginalParent) {
            this.modalOriginalParent.insertBefore(this.modal, this.modalNextSibling);
          } else {
            this.modalOriginalParent.appendChild(this.modal);
          }
        }

        closeVideoModal({ restoreFocus = true } = {}) {
          if (!this.modal || !this.modalPaused) return;

          this.modalPlayer?.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.load();
          });
          this.modalPlayer?.replaceChildren();
          this.modal.classList.remove('is-open');
          this.modal.hidden = true;
          this.modal.setAttribute('aria-hidden', 'true');
          this.modalPaused = false;
          this.restoreModalPosition();

          if (!document.querySelector('.pc-inner-ring__modal.is-open')) {
            document.documentElement.classList.remove('pc-inner-ring-modal-open');
          }

          this.lastMobileAdvance = performance.now();
          this.lastFrame = this.lastMobileAdvance;

          if (restoreFocus && this.lastFocusedElement?.isConnected) {
            this.lastFocusedElement.focus({ preventScroll: true });
          }
          this.lastFocusedElement = null;
          this.startAnimation();
        }

        isAutoplayPaused() {
          return (
            document.hidden ||
            !this.inViewport ||
            this.hoverPaused ||
            this.modalPaused ||
            this.isDragging ||
            this.count < 2 ||
            this.reducedMotionQuery.matches
          );
        }

        shouldAnimate() {
          if (this.reducedMotionQuery.matches || document.hidden || !this.inViewport || this.count < 2) {
            return false;
          }

          const autoplayActive = this.autoplay && !this.isAutoplayPaused();
          const positionIsMoving = Math.abs(this.target - this.position) > 0.001;
          const inertiaIsMoving = Math.abs(this.velocity) > 0.002;
          return autoplayActive || this.isDragging || positionIsMoving || inertiaIsMoving;
        }

        startAnimation(force = false) {
          if (
            this.animationFrame ||
            document.hidden ||
            !this.inViewport ||
            this.count < 2 ||
            this.reducedMotionQuery.matches
          ) {
            return;
          }
          if (!force && !this.shouldAnimate()) return;

          this.lastFrame = performance.now();
          this.animationFrame = requestAnimationFrame((time) => this.animate(time));
        }

        stopAnimation() {
          if (!this.animationFrame) return;
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }

        animate(time) {
          // 桌面端连续滚动，移动端按卡片吸附；无运动时自动停止 rAF。
          this.animationFrame = null;
          if (!this.inViewport || document.hidden || this.count < 2) return;

          const deltaTime = Math.min((time - this.lastFrame) / 1000, 0.04);
          this.lastFrame = time;

          if (!this.isDragging) {
            if (this.isMobile) {
              if (this.reducedMotionQuery.matches) {
                this.position = this.target;
              } else {
                const easing = 1 - Math.exp(-12 * deltaTime);
                this.position += (this.target - this.position) * easing;

                if (
                  this.autoplay &&
                  !this.isAutoplayPaused() &&
                  time - this.lastMobileAdvance >= this.mobileDelay &&
                  Math.abs(this.target - this.position) < 0.01
                ) {
                  this.position = this.target;
                  this.target = Math.round(this.target) + 1;
                  this.lastMobileAdvance = time;
                }
              }
            } else if (!this.reducedMotionQuery.matches) {
              if (this.autoplay && !this.isAutoplayPaused()) {
                this.position += this.desktopSpeed * deltaTime;
                this.target = this.position;
              }

              if (Math.abs(this.velocity) > 0.002) {
                this.position += this.velocity * deltaTime;
                this.target = this.position;
                this.velocity *= Math.pow(0.035, deltaTime);
              } else {
                this.velocity = 0;
              }
            }
          }

          if (Math.abs(this.position) > this.count * 100) {
            const cycles = Math.trunc(this.position / this.count);
            this.position -= cycles * this.count;
            this.target -= cycles * this.count;
          }

          this.draw();
          if (this.shouldAnimate()) {
            this.animationFrame = requestAnimationFrame((nextTime) => this.animate(nextTime));
          }
        }

        draw() {
          if (!this.cardStep || !this.carousel.clientWidth) return;

          let closestIndex = 0;
          let closestDistance = Infinity;
          const viewportWidth = this.carousel.clientWidth;
          const visibleLimit = viewportWidth / 2 + this.cardWidth;

          this.cards.forEach((card, index) => {
            const distanceFromPosition = this.wrapDelta(index - this.position);
            const absoluteDistance = Math.abs(distanceFromPosition);
            const x = distanceFromPosition * this.cardStep;
            const visible = Math.abs(x) <= visibleLimit;

            card.classList.toggle('is-render-visible', visible);

            if (this.isMobile) {
              card.style.transform = `translate3d(calc(-50% + ${x.toFixed(2)}px), -50%, 0)`;
              card.style.opacity = visible ? '1' : '0';
              card.style.zIndex = String(30 - Math.round(absoluteDistance * 5));
              card.style.pointerEvents = absoluteDistance < 0.55 ? 'auto' : 'none';
            } else {
              const sideAmount = Math.min(absoluteDistance, 2.45);
              const verticalScale = 1 + Math.pow(sideAmount / 2.45, 1.35) * 0.16;
              const angle = this.clamp(distanceFromPosition * -11.5, -42, 42);
              const horizontalCompensation = 1 / Math.cos((angle * Math.PI) / 180);
              const lift = Math.pow(sideAmount, 1.25) * Math.max(this.cardWidth / 88, 1);
              const perspective = Math.max(viewportWidth * 0.573, 760);

              card.style.transform = `translate3d(calc(-50% + ${x.toFixed(2)}px), calc(-50% - ${lift.toFixed(2)}px), 0) perspective(${perspective.toFixed(2)}px) rotateY(${angle.toFixed(2)}deg) scale3d(${horizontalCompensation.toFixed(4)}, ${verticalScale.toFixed(4)}, 1)`;
              card.style.opacity = visible ? '1' : '0';
              card.style.zIndex = String(Math.round(sideAmount * 20) + 10);
              card.style.pointerEvents = visible ? 'auto' : 'none';
            }

            if (absoluteDistance < closestDistance) {
              closestDistance = absoluteDistance;
              closestIndex = index;
            }
          });

          this.updateActiveCard(closestIndex);
        }

        updateActiveCard(index) {
          if (index === this.activeRenderIndex) return;
          this.activeRenderIndex = index;

          const activeSourceIndex = Number(this.cards[index]?.dataset.sourceIndex || 0);

          this.cards.forEach((card, cardIndex) => {
            const active = cardIndex === index;
            card.classList.toggle('is-active', active);

            if (card.matches('a')) card.tabIndex = active ? 0 : -1;
            card.querySelectorAll('[data-ring-video-trigger], [data-ring-card-link]').forEach((control) => {
              control.tabIndex = active ? 0 : -1;
            });

            if (active) {
              card.setAttribute('aria-current', 'true');
              card.setAttribute('aria-hidden', 'false');
            } else {
              card.removeAttribute('aria-current');
              card.setAttribute('aria-hidden', 'true');
            }
          });

          if (this.progressText) {
            this.progressText.textContent = `${String(activeSourceIndex + 1).padStart(2, '0')} / ${String(this.count).padStart(2, '0')}`;
          }

          if (this.progressFill) {
            this.progressFill.style.transform = `scaleX(${(activeSourceIndex + 1) / this.count})`;
          }
        }

        wrapDelta(value) {
          if (this.renderCount <= 1) return value;
          return (
            ((value + this.renderCount / 2) % this.renderCount + this.renderCount) % this.renderCount -
            this.renderCount / 2
          );
        }

        clamp(value, min, max) {
          return Math.min(Math.max(value, min), max);
        }

        selectBlock(blockId) {
          const index = this.originalCards.findIndex((card) => card.dataset.blockId === blockId);
          if (index < 0) return;

          this.position = index;
          this.target = index;
          this.velocity = 0;
          this.lastMobileAdvance = performance.now();
          this.startAnimation();
          this.draw();
        }

        destroy() {
          if (this.modalPaused) this.closeVideoModal({ restoreFocus: false });
          this.restoreModalPosition();
          this.stopAnimation();
          if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
          window.clearTimeout(this.resizeTimer);
          this.abortController.abort();
          this.resizeObserver?.disconnect();
          this.intersectionObserver?.disconnect();

          if (typeof this.mobileQuery.removeListener === 'function' && typeof this.mobileQuery.removeEventListener !== 'function') {
            this.mobileQuery.removeListener(this.modeChangeHandler);
          }

          this.root.querySelectorAll('[data-ring-clone]').forEach((card) => card.remove());
          this.root.removeAttribute('data-initialized');
          delete this.root.__pcInnerRingCarousel;
        }
      }

      window.PcInnerRingCarousel = {
        init(scope = document) {
          const roots = [];
          if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
          if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));

          roots.forEach((root) => {
            if (!root.__pcInnerRingCarousel && root.dataset.initialized !== 'true') {
              new InnerRingCarousel(root);
            }
          });
        },

        destroy(scope) {
          const roots = [];
          if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
          if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
          roots.forEach((root) => root.__pcInnerRingCarousel?.destroy());
        }
      };

      // 兼容 Shopify Theme Editor 的 Section 加载、卸载和 Block 选中。
      document.addEventListener('shopify:section:load', (event) => {
        window.PcInnerRingCarousel.init(event.target);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        window.PcInnerRingCarousel.destroy(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const root = event.target.closest?.(ROOT_SELECTOR);
        root?.__pcInnerRingCarousel?.selectBlock(event.target.dataset.blockId);
      });
    }

    const initialize = () => window.PcInnerRingCarousel.init(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(text, fallback) {
      var slug = text.normalize('NFKC').toLowerCase().trim()
        .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
        .replace(/^-+|-+$/g, '');
      return slug || fallback;
    }

    function initArticle(root) {
      if (!root || root.dataset.articleInitialized === 'true') return;
      root.dataset.articleInitialized = 'true';

      var articleBody = root.querySelector('[data-article-body]');
      var articleContent = root.querySelector('[data-article-content]');
      var grid = root.querySelector('[data-article-grid]');
      var tocSelector = root.dataset.tocLevels === 'h2_h3' ? 'h2, h3' : 'h2';
      var headings = articleContent ? Array.from(articleContent.querySelectorAll(tocSelector)).filter(function (heading) {
        return heading.textContent.trim() !== '';
      }) : [];
      var minimum = Number(root.dataset.tocMin || 3);
      var desktopList = root.querySelector('[data-toc-list]');
      var mobileList = root.querySelector('[data-mobile-toc-list]');
      var desktopRail = root.querySelector('[data-desktop-toc]');
      var desktopTocScroller = desktopList;
      var mobileToc = root.querySelector('[data-mobile-toc]');
      var usedIds = new Set();

      headings.forEach(function (heading, index) {
        var baseId = heading.id || slugify(heading.textContent, 'section-' + (index + 1));
        var uniqueId = baseId;
        var suffix = 2;
        while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
          uniqueId = baseId + '-' + suffix;
          suffix += 1;
        }
        heading.id = uniqueId;
        usedIds.add(uniqueId);
      });

      if (headings.filter(function (heading) { return heading.tagName === 'H2'; }).length < minimum) {
        if (desktopRail) desktopRail.remove();
        if (mobileToc) mobileToc.remove();
        if (grid) {
          grid.classList.remove('has-toc', 'article-grid--three', 'article-grid--two-toc');
          grid.classList.add(grid.classList.contains('has-right-rail') ? 'article-grid--two-right' : 'article-grid--single');
        }
        headings = [];
      }

      function createTocItem(heading) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.classList.add('is-subheading');
        item.appendChild(link);
        return item;
      }

      headings.forEach(function (heading) {
        if (desktopList) desktopList.appendChild(createTocItem(heading));
        if (mobileList) mobileList.appendChild(createTocItem(heading));
      });

      var allTocLinks = Array.from(root.querySelectorAll('[data-toc-list] a, [data-mobile-toc-list] a'));
      var desktopTocLinks = desktopList ? Array.from(desktopList.querySelectorAll('a')) : [];
      function setActive(id) {
        var activeDesktopLink = null;
        allTocLinks.forEach(function (link) {
          var isActive = link.getAttribute('href') === '#' + id;
          link.classList.toggle('is-active', isActive);
          if (isActive && link.closest('[data-toc-list]')) activeDesktopLink = link;
        });

        if (activeDesktopLink && desktopTocScroller) {
          if (activeDesktopLink === desktopTocLinks[0]) {
            desktopTocScroller.scrollTop = 0;
            return;
          }
          if (activeDesktopLink === desktopTocLinks[desktopTocLinks.length - 1]) {
            desktopTocScroller.scrollTop = desktopTocScroller.scrollHeight - desktopTocScroller.clientHeight;
            return;
          }
          var linkRect = activeDesktopLink.getBoundingClientRect();
          var scrollerRect = desktopTocScroller.getBoundingClientRect();
          if (linkRect.top < scrollerRect.top) {
            desktopTocScroller.scrollTop += linkRect.top - scrollerRect.top;
          } else if (linkRect.bottom > scrollerRect.bottom) {
            desktopTocScroller.scrollTop += linkRect.bottom - scrollerRect.bottom;
          }
        }
      }

      root.addEventListener('click', function (event) {
        var tocLink = event.target.closest('[data-toc-list] a, [data-mobile-toc-list] a');
        if (tocLink && root.contains(tocLink)) {
          var target = root.querySelector(tocLink.getAttribute('href'));
          if (target) {
            event.preventDefault();
            var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            var isMobileTocLink = Boolean(tocLink.closest('[data-mobile-toc]'));
            var mobilePanel = mobileToc ? mobileToc.querySelector('[data-mobile-toc-panel]') : null;

            if (isMobileTocLink && mobileToc) {
              if (mobilePanel) mobilePanel.style.transition = 'none';
              mobileToc.classList.remove('is-open');
              var toggle = mobileToc.querySelector('[data-mobile-toc-toggle]');
              if (toggle) toggle.setAttribute('aria-expanded', 'false');
              if (mobilePanel) void mobilePanel.offsetHeight;
              requestAnimationFrame(function () {
                target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
                history.pushState(null, '', tocLink.getAttribute('href'));
                if (mobilePanel) {
                  requestAnimationFrame(function () {
                    mobilePanel.style.removeProperty('transition');
                  });
                }
              });
            } else {
              target.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
              history.pushState(null, '', tocLink.getAttribute('href'));
            }
          }
        }

        var copyButton = event.target.closest('[data-share-copy]');
        if (copyButton && root.contains(copyButton)) {
          var share = copyButton.closest('[data-article-share]');
          var value = window.location.href;
          var status = share ? share.querySelector('[data-share-status]') : null;
          var successMessage = copyButton.dataset.copySuccess || root.dataset.copySuccess;

          function markCopySuccess() {
            if (status) status.textContent = successMessage;
          }

          function copyWithFallback(text) {
            var input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            var copied = document.execCommand('copy');
            input.remove();
            return copied;
          }

          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(value).then(function () {
              markCopySuccess();
            }).catch(function () {
              if (copyWithFallback(value)) markCopySuccess();
            });
          } else if (copyWithFallback(value)) {
            markCopySuccess();
          }
        }
      });

      var mobileToggle = root.querySelector('[data-mobile-toc-toggle]');
      if (mobileToggle && mobileToc) {
        mobileToggle.addEventListener('click', function () {
          var open = mobileToc.classList.toggle('is-open');
          mobileToggle.setAttribute('aria-expanded', String(open));
        });
      }

      var progress = root.querySelector('[data-reading-progress]');
      var progressBar = root.querySelector('[data-reading-progress-bar]');
      var backToTop = root.querySelector('[data-back-to-top]');
      var ticking = false;

      function updateScrollUI() {
        ticking = false;
        if (!articleBody) return;
        var rect = articleBody.getBoundingClientRect();
        var articleTop = window.scrollY + rect.top;
        var distance = Math.max(1, articleBody.offsetHeight - window.innerHeight);
        var value = Math.min(1, Math.max(0, (window.scrollY - articleTop) / distance));

        if (progress && progressBar) {
          var shortArticle = articleBody.offsetHeight <= window.innerHeight;
          progress.hidden = shortArticle;
          progressBar.style.width = (value * 100) + '%';
        }

        if (backToTop) backToTop.classList.toggle('is-visible', window.scrollY > 800);

        var readingLine = Math.min(180, window.innerHeight * .22);
        var current = headings[0];
        headings.forEach(function (heading) {
          if (heading.getBoundingClientRect().top <= readingLine) current = heading;
        });
        if (articleContent && articleContent.getBoundingClientRect().bottom <= window.innerHeight + 1 && headings.length) {
          current = headings[headings.length - 1];
        }
        if (current) setActive(current.id);
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateScrollUI);
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateScrollUI();

      if (backToTop) {
        backToTop.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }

      if (articleContent) {
        var contentImages = Array.from(articleContent.querySelectorAll('img'));
        contentImages.forEach(function (image, index) {
          image.decoding = 'async';
          if (index === 0 && root.dataset.hasFeatured !== 'true') {
            image.loading = 'eager';
            image.fetchPriority = 'high';
          } else if (!image.hasAttribute('loading')) {
            image.loading = 'lazy';
          }
        });
      }

      if (root.dataset.lightbox === 'true') {
        var dialog = root.querySelector('[data-image-dialog]');
        var dialogImage = root.querySelector('[data-dialog-image]');
        var dialogCaption = root.querySelector('[data-dialog-caption]');
        var closeButton = root.querySelector('[data-dialog-close]');
        var lastTrigger;

        function closeDialog() {
          if (dialog && dialog.open) dialog.close();
        }

        if (dialog && articleContent) {
          articleContent.querySelectorAll('figure').forEach(function (figure) {
            if (figure.querySelector('a, button')) return;
            var image = figure.querySelector('img');
            if (!image) return;
            var caption = figure.querySelector('figcaption');
            var accessibleText = (caption ? caption.textContent : image.alt) || '';
            figure.tabIndex = 0;
            figure.setAttribute('role', 'button');
            figure.setAttribute('aria-label', accessibleText + (accessibleText ? '. ' : '') + root.dataset.lightboxOpen);

            function openDialog() {
              lastTrigger = figure;
              dialogImage.src = image.currentSrc || image.src;
              dialogImage.alt = image.alt || '';
              dialogCaption.textContent = caption ? caption.textContent.trim() : (image.alt || '');
              document.body.classList.add('is-article-modal-open');
              dialog.showModal();
            }

            figure.addEventListener('click', openDialog);
            figure.addEventListener('keydown', function (event) {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openDialog();
              }
            });
          });

          if (closeButton) closeButton.addEventListener('click', closeDialog);
          dialog.addEventListener('click', function (event) {
            if (event.target === dialog) closeDialog();
          });
          dialog.addEventListener('close', function () {
            document.body.classList.remove('is-article-modal-open');
            dialogImage.src = '';
            if (lastTrigger) lastTrigger.focus();
          });
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-article-template]').forEach(initArticle);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Klarna 节点可能不存在或 Shadow DOM 尚未初始化，增加空值保护避免阻断后续脚本。
  const shadowHost = document.querySelector('klarna-placement[data-key="credit-promotion-badge"]');
  if (shadowHost && shadowHost.shadowRoot) {
    const osmContainer = shadowHost.shadowRoot.querySelector('.osm-container');
    if (osmContainer) {
      osmContainer.style.backgroundColor = 'lightblue';
      osmContainer.style.padding = '10px';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
